import { useEffect, useRef, useState } from 'react';
import apiService from '../../../services/ApiService';
import classes from '../css/QuestionCard.module.css';

type Props = {
  questionId: number;
};

export function QuestionImageFromApi({ questionId }: Props) {
  const [src, setSrc] = useState<string | null>(null);
  const objectUrlRef = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const revoke = () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };

    revoke();
    setSrc(null);

    (async () => {
      try {
        const blob = await apiService.getQuestionImageBlob(questionId);
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        objectUrlRef.current = url;
        setSrc(url);
      } catch {
        if (!cancelled) setSrc(null);
      }
    })();

    return () => {
      cancelled = true;
      revoke();
    };
  }, [questionId]);

  if (!src) return null;

  return <img src={src} alt="" className={classes.questionImage} loading="lazy" />;
}
